import { render, staticRenderFns } from "./CardTransactionsTable.vue?vue&type=template&id=1d8c680e&scoped=true&"
import script from "./CardTransactionsTable.vue?vue&type=script&lang=js&"
export * from "./CardTransactionsTable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=1d8c680e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8c680e",
  null
  
)

export default component.exports